var _ = require("lodash");

export default function calendarIsSame (first, second) {
   return _.isEqual(first, second);    
};

